import React from 'react';
import { H3, Text } from 'atoms';

export const ContentBlock1 = () => (
    <div className='ecb1'>
        <div className='ecb1__content'>
            <div className='ecb1__heading'>
                <H3 style={{ color: '#121651' }}>
                    What is ESSER and how can you access funds?
                </H3>
                <Text style={{ textAlign: 'left' }} mt={4} mb={6}>
                    Education funding under the American Rescue Plan (ARP) – known as
                    Elementary and Secondary School Emergency Relief Funds or ESSER –
                    focuses on helping schools safely reopen and address the impact of
                    the pandemic on students.&nbsp;
                </Text>
            </div>
            <div className='ecb1__blocks'>
                <div className='ecb1__block-1 rich-text-block'>
                    <ul>
                        <li>
                            New ESSER funds total $170B and include $122.7 billion for K-12
                            state education agencies (with $800 million allocated for
                            children experiencing homelessness).
                        </li>
                        <li>
                            SEAs may access two-thirds of ESSER funds immediately with
                            remaining funds available after states submit implementation
                            plans.
                        </li>
                        <li>
                            SEAs must subgrant at least 90% of total ARP ESSER funds to LEAs
                            (including charter schools that are LEAs).
                        </li>
                        <li>
                            LEAs must use at least 20% of ESSER funds for evidence-based
                            interventions that accelerate learning recovery; the remaining
                            funds may be used for a wide array of uses pertaining to needs
                            that have arisen due to COVID-19.
                        </li>
                        <li>
                            Within 30 days of receiving their allocations from the state,
                            LEAs must publish plans for reopening schools for in-person
                            learning.
                        </li>
                    </ul>
                </div>
                <div className='ecb1__block-2'>
                    <img src='/assets/graphics/esser-pie.png' alt='Pie Chart' />
                </div>
            </div>
        </div>
        <style jsx>{`
            .ecb1 {
                width: 100%;
                padding: 48px 60px;

                .ecb1__content {
                    max-width: 1100px;
                    margin: 0 auto;

                    .ecb1__heading {
                        text-align: center;
                    }

                    .ecb1__blocks {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .ecb1__block-1 {
                            width: 100%;
                            max-width: 500px;
                        }

                        .ecb1__block-2 {
                            width: 100%;
                            max-width: 520px;

                            img {
                                width: 100%;
                            }
                        }
                    }
                }
            }

            @media (max-width: 992px) {
                .ecb1 {
                    padding: 48px 40px;

                    .ecb1__content {
                        .ecb1__blocks {
                            flex-direction: column-reverse;
                            margin: 0 auto;
                            width: 100%;
                        }
                    }
                }
            }

            @media (max-width: 480px) {
                .ecb1 {
                    padding: 48px 20px;
                }
            }
        `}</style>
    </div>
);
